import React from "react";

import storage from "commons/utils/storage";

import { WhoAmIResponse } from "types/api/user";

const defaultUser: WhoAmIResponse = {
    id: "",
    first_name: "",
    last_name: "",
    authorities: [],
};

export const UserContext = React.createContext(defaultUser);

export const UserActionsContext = React.createContext({
    storeUserData: (userToSet: WhoAmIResponse) => {
        console.error("Undefined function -> storeUserData", userToSet);
    },
    clearUserData: () => {
        console.error("Undefined function -> clearUserData");
    },
});

export const useUserContext = () => React.useContext(UserContext);

export const useUserActionsContext = () => React.useContext(UserActionsContext);

type PropsType = {
    children: any;
};

export const UserContextProvider = (props: PropsType) => {
    const [userData, setUserData] = React.useState<WhoAmIResponse>(() => {
        let storedUser = storage.get("user");

        if (!storedUser) {
            storedUser = defaultUser;
        }

        return storedUser;
    });

    const storeUserData = React.useCallback((userToSet: WhoAmIResponse) => {
        storage.set("user", userToSet);

        setUserData(userToSet);
    }, []);

    const clearUserData = React.useCallback(() => {
        storage.remove("user");
    }, []);

    const userActionsValues = React.useMemo(
        () => ({
            storeUserData,
            clearUserData,
        }),
        [storeUserData, clearUserData]
    );

    return (
        <UserContext.Provider value={userData}>
            <UserActionsContext.Provider value={userActionsValues}>
                {props.children}
            </UserActionsContext.Provider>
        </UserContext.Provider>
    );
};
